import {
  EVENT_NAME_DRAG_END,
  EVENT_NAME_DRAG_ENTER,
  EVENT_NAME_DRAG_LEAVE,
  EVENT_NAME_DRAG_OVER,
  EVENT_NAME_DROP,
  EVENT_NAME_MOUSE_UP,
} from '../../constants/event'
import { MAIN_MOUSE_BUTTON } from '../../constants/mouse'
import { preventDefault } from '../../utils/events'

import { DRAGGING_OVER_CAPTURE_OPTIONS } from './useDraggingOver.constants'

export function createDragHandlers(node, setDragging, draggingStateRef) {
  function enter(e) {
    preventDefault(e)
    setDragging(true)
  }

  function over(e) {
    preventDefault(e)
  }

  function leave(e) {
    preventDefault(e)
    const related = e.relatedTarget

    if (related && node.contains(related)) {
      return
    }

    setDragging(false)
  }

  function drop(e) {
    preventDefault(e)
    setDragging(false)
  }

  function mouseUp(e) {
    if (e.button === MAIN_MOUSE_BUTTON) {
      setDragging(false)
    }
  }

  //file left component
  function outsideOver(e) {
    if (!e.target) {
      return
    }

    if (!node.contains(e.target) && draggingStateRef?.current) {
      setDragging(false)
    }
  }

  function end() {
    setDragging(false)
  }

  return {
    drop,
    end,
    enter,
    leave,
    mouseUp,
    outsideOver,
    over,
  }
}

export function addDragListeners(node, handlers) {
  if (!node || !handlers) {
    return
  }

  node.addEventListener(
    EVENT_NAME_DRAG_ENTER,
    handlers.enter,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )
  node.addEventListener(
    EVENT_NAME_DRAG_OVER,
    handlers.over,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )
  node.addEventListener(
    EVENT_NAME_DRAG_LEAVE,
    handlers.leave,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )
  node.addEventListener(
    EVENT_NAME_DROP,
    handlers.drop,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )

  window.addEventListener(
    EVENT_NAME_MOUSE_UP,
    handlers.mouseUp,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )
  window.addEventListener(
    EVENT_NAME_DRAG_OVER,
    handlers.outsideOver,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )
  window.addEventListener(
    EVENT_NAME_DRAG_END,
    handlers.end,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )
}

export function removeDragListeners(node, handlers) {
  if (!node || !handlers) {
    return
  }

  node.removeEventListener(
    EVENT_NAME_DRAG_ENTER,
    handlers.enter,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )
  node.removeEventListener(
    EVENT_NAME_DRAG_OVER,
    handlers.over,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )
  node.removeEventListener(
    EVENT_NAME_DRAG_LEAVE,
    handlers.leave,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )
  node.removeEventListener(
    EVENT_NAME_DROP,
    handlers.drop,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )

  window.removeEventListener(
    EVENT_NAME_MOUSE_UP,
    handlers.mouseUp,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )
  window.removeEventListener(
    EVENT_NAME_DRAG_OVER,
    handlers.outsideOver,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )
  window.removeEventListener(
    EVENT_NAME_DRAG_END,
    handlers.end,
    DRAGGING_OVER_CAPTURE_OPTIONS
  )
}
